<div class="tabs">
  <div class="tabs-items">
    <div class="item" *ngFor="let item of items; let i = index">
      <input 
        type="radio" 
        class="custom-input-radio"
        id="{{name}}-{{i}}" 
        [name]="name" 
        [value]="item.value"
        [ngModel]="value"
        (ngModelChange)="modelChange($event, i)" 
        [checked]="selected == item.value" />
      <label for="{{name}}-{{i}}">{{ item.label }}</label>
    </div>
  </div>
  <div class="slider" [ngStyle]="{'width': sliderWidth, 'left': sliderPosition}"></div>
</div>